





































import { defineComponent, useFetch, ref, useContext } from '@nuxtjs/composition-api'
import { getTopicHighlightsFilters } from '~/utils/solepro/products';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { useConfig } from '~/composables';
import { areaTematicaButtonTrack, areaTematicaGammaTrack } from '~/helpers/trackings/24orepro/home';

export default defineComponent({
    setup() {
        const allCategories = ref([]);
        const categoryStore = useCategoryStore();
        const topicHighlights = ref([]);
        const { app } = useContext();
        const { config } = useConfig();

        useFetch(async () => {        
            await categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            topicHighlights.value = await getTopicHighlightsFilters(allCategories.value, app, config);
        });

        return {
            topicHighlights,
            storeCode: config.value.store_code,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    methods: {
        trackAreaTematicaButton(val, callback) {
            areaTematicaButtonTrack(val, callback)
        },
        trackAreaTematicaGamma(cName, scName, callback) {
            areaTematicaGammaTrack(cName, scName, callback)
        },
        goToLink(link) {
            location.href = link;
    },
    }
})
